import MonitoringSearchPage from '../../components/Monitoring/MonitoringSearchPage'
import { useMonitoringCache } from '../../hooks/useMonitoringCache'

export default function MonitoringSearch() {
  const cache = useMonitoringCache()
  return <MonitoringSearchPage {...cache.get()} />
}
